import { action } from 'typesafe-actions';

import { SET_MAP_STYLES, GET_MAP_STYLES, RESET_MAP_STYLES } from './constants';

export const getMapStyles = () => action(GET_MAP_STYLES);

export const setMapStyles = (mapStyles: mapboxgl.Style) => action(SET_MAP_STYLES, mapStyles);

export const resetMapStyles = () => action(RESET_MAP_STYLES);
